import { useCallback, useReducer } from "react";
import * as Actions from "../actions";
import { getInitialScheduleFormState } from "../constants/initialStates";
import { liveSessionScheduleFormReducer } from "../reducer";

export const useLiveSessionScheduleFormActions = ({ initialData = null } = {}) => {
  const [scheduleFormState, dispatch] = useReducer(liveSessionScheduleFormReducer, {}, () =>
    getInitialScheduleFormState({ initialData, skipFieldValidations: !initialData })
  );

  const updateScheduleFormTitleInput = useCallback(
    (value) => {
      dispatch(Actions.updateScheduleFormTitleInput(value));
    },
    [dispatch]
  );

  const updateScheduleFormDateInput = useCallback(
    (value) => dispatch(Actions.updateScheduleFormDateInput(value)),
    [dispatch]
  );

  const updateScheduleFormTimeInput = useCallback(
    (value) => dispatch(Actions.updateScheduleFormTimeInput(value)),
    [dispatch]
  );

  const updateScheduleFormLanguageInput = useCallback(
    (value) => dispatch(Actions.updateScheduleFormLanguageInput(value)),
    [dispatch]
  );

  const updateScheduleFormDescriptionInput = useCallback(
    (value) => dispatch(Actions.updateScheduleFormDescriptionInput(value)),
    [dispatch]
  );

  return {
    scheduleFormState,
    updateScheduleFormTitleInput,
    updateScheduleFormDateInput,
    updateScheduleFormTimeInput,
    updateScheduleFormLanguageInput,
    updateScheduleFormDescriptionInput,
  };
};
